// extracted by mini-css-extract-plugin
module.exports = {"ratings":"RatingAndReviews_ratings__d2Sdg","ratingText":"RatingAndReviews_ratingText__g55DD","link":"RatingAndReviews_link__BZzkJ"};